import { useNavigate } from "react-router-dom";
import { activeAttention } from "../../domain/operationsQueries";
import { useOperations } from "../../state/OperationsProvider";
import { AttentionCard } from "../today/AttentionCard";

export function AttentionPage() {
  const navigate = useNavigate();
  const { snapshot, resolveAttention } = useOperations();
  if (!snapshot) return null;
  const items = activeAttention(snapshot);

  return (
    <section className="attention-page">
      <div className="section-heading"><div><h2>Needs attention</h2><p>Active Events only. Cancelled Events keep history on the Event record.</p></div></div>
      <div className="attention-page-list">
        {items.map((item) => {
          const event = snapshot.events.find((entry) => entry.id === item.eventId);
          return event ? <AttentionCard key={item.id} item={item} event={event} onReview={() => navigate(`/events/${event.id}`)} onResolve={() => resolveAttention(item.id)} /> : null;
        })}
        {items.length === 0 && <div className="empty-state"><strong>All clear</strong><p>No unresolved attention items in active Operations.</p></div>}
      </div>
    </section>
  );
}
